import React from 'react';
import { isNotEmpty, parseVideo } from '../../lib/ep.js';

import LeveledHTMLText from './helpers/LeveledHTMLText.js';
import VideoEmbed from './VideoEmbed';

const PromoColsWrapper = (props) => {
	let main_image = false;
	let main_video = false;
	if(props.main_image != undefined && props.main_image != "") {
		main_image = props.main_image;
	} else if(props.main_video != undefined && props.main_video != "") {
		//main_video = props.main_video;
		main_video = (typeof props.main_video == 'string') ? parseVideo(props.main_video) : props.main_video;
	}
	
	const main_description = (isNotEmpty(props, 'main_description')) ? props.main_description : false;

	return (
		<div class={`flex_cols gui_pos_rel ${props?.extra_classes ?? ''}`}>
			{(main_image || main_video) && (
				<div class="flex_col col_1">
					{(!main_video && main_image) && (
						<img src={main_image} alt="" style={{maxWidth:'100%'}} />
					)}

					{(main_video) && (
						<VideoEmbed video_url={main_video.full_url} video_thumb={main_video.image} />
					)}
				</div>
			)}

			<div class="flex_col col_2">
				{(main_description) && (
					<article class="gui_main_text_color_on_bg" style={{marginBottom:'1em'}}>
						<LeveledHTMLText
							_class={{ other:'fill_description' }}
						>{main_description}</LeveledHTMLText>
					</article>
				)}

				{props.children}
			</div>
		</div>
	)
};

export default PromoColsWrapper;